import Colors from 'assets/Colors.js';
import styled from 'styled-components';

const Wrapper = styled.div`
  margin-bottom: 39px;
`;

const SectionTitle = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  letter-spacing: 0.01em;
  line-height: 18px;
`;

const Title = styled.div`
  color: ${Colors.primary};
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  letter-spacing: 0.01em;
  line-height: 18px;
  margin-bottom: 18px;
`;

const text = styled.div`
  margin-top: 10px;
  margin-bottom: 8px;
  font-size: 12px;
  font-style: normal;
  font-weight: 300;
  color: ${Colors.text_primary};
`;

const Line = styled.div`
  background: ${Colors.background_dividers};
  height: 1px;
  width: 100%;
`;

const Additem = styled.a`
  text-decoration: underline;
  font-size: 12px;
  font-weight: 300;
  color: ${Colors.text_primary};
`;

const SubTitle = styled.div`
  color: ${Colors.primary};
  font-size: 12px;
  font-style: normal;
  font-weight: 300;
  letter-spacing: 0.01em;
  line-height: 18px;
  margin-bottom: 10px;
`;

const deleteCourse = styled.a`
  font-size: 12px;
  color: ${Colors.text_secondary};
  text-decoration: underline;
  margin-bottom: 18px;
`;

const ButtonaddCourse = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${Colors.BG_MENU};
  height: 47px;
  width: 100%;
  letter-spacing: 0.01em;
  line-height: 18px;
  cursor: pointer;
  margin-bottom: 18px;
`;

const addCourseText = styled.a`
  margin-left: 10px;
  font-size: 12px;
  font-weight: 300;
  color: ${Colors.text_primary};
  &:hover {
    color: ${Colors.primary};
  }
`;
const TableCell = styled.div`
  height: 48px;
  display: flex;
  align-items: center;
  padding-left: 20px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export default {
  text,
  deleteCourse,
  Line,
  SectionTitle,
  Title,
  SubTitle,
  Additem,
  ButtonaddCourse,
  addCourseText,
  Wrapper,
  TableCell,
};
